import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["text"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-05-18 11:28:39
 * @LastEditTime: 2021-07-02 15:12:06
 * @LastEditors: wangshengqiang
 * @Description: 文案
 */
import React from 'react';
import classnames from 'classnames';
import Content from '@/components/Content';
import './index.less';
const Text = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    attrs,
    children,
    className
  } = props;

  const {
    text
  } = attrs,
        others = _objectWithoutProperties(attrs, _excluded);

  const cls = classnames({
    'components-modal-text-render': true,
    [className]: !!className
  });
  const dangerouslySetInnerHTML = {
    __html: text
  };
  return /*#__PURE__*/React.createElement(Content, _extends({
    ref: ref,
    className: cls,
    dangerouslySetInnerHTML: dangerouslySetInnerHTML
  }, others));
});
export default Text;